import React, { Component } from 'react';
import classNames from 'classnames';
import { Prism } from 'vendors/prism';
import { getSelectedBlock } from 'lib/helpers';
import { Modifier, EditorState } from 'draft-js';
import Immutable from 'immutable';

const supportedSyntaxes = Object.keys(Prism.languages).filter(x => typeof Prism.languages[x] === 'object');

supportedSyntaxes.sort();

export function SyntaxSelector({ theme, disabled, store }) {
	const block = getSelectedBlock(store.getEditorState(), true);
	if (!block || block.getType() !== 'code-block') {
		return null;
	}
	const data = block.getData();
	const syntax = data && data.get('syntax') || 'js';

	const changeSyntax = (nextSyntax) => {
		const editorState = store.getEditorState();
		const newContent = Modifier.mergeBlockData(
			editorState.getCurrentContent(),
			editorState.getSelection(),
			Immutable.Map({ syntax: nextSyntax }),
		);
		store.setEditorState(
			EditorState.push(
				EditorState.forceSelection(editorState, editorState.getSelection()),
				newContent,
				'change-block-data'
			),
		);
	};

	return (
		<div
			className={theme.buttonWrapper}
			// mousedown 不能冒泡到工具栏，否则 select 打开的事件会在外面阻止
			onMouseDown={evt => evt.stopPropagation()}>
			<select className="code-syntax-select" value={syntax} onChange={evt => changeSyntax(evt.target.value)}>
				{ supportedSyntaxes.map(supportedSyntax => (
					<option key={supportedSyntax} value={supportedSyntax}>{supportedSyntax}</option>
				))}
			</select>
		</div>
	)
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/codeEditPlugin/SyntaxSelector.jsx